<template>
    <div id="meetingConferenceIframeId" class="conference_frame"></div>
</template>
<script>
/* eslint-disable */
export default {
    props: {
        roomId: String,
        meetingInfo: Object,
        currentUser: Object,
        mType:String
    },

    data() {
        return {
          domain: process.env.VUE_APP_VIDEO_DOMAIN
        }
    },

    mounted() {
        this._api = null;
        this.startMeeting();
    },

    methods: {
        startMeeting() {
            if (!window.JitsiMeetExternalAPI || this._api) {
                return;
            }

            const options = {
                roomName: this.roomId,
                parentNode: document.getElementById(
                    "meetingConferenceIframeId"
                ),
                width: "100%",
                height: "100%",
                jwt: this.meetingInfo.token,
                userInfo: {
                    displayName: `${this.currentUser.first_name} ${this.currentUser.last_name}`,
                    email: this.currentUser.email
                }
            };

            this._api = new window.JitsiMeetExternalAPI(
                this.domain,
                options
            );

            this._api.addEventListener(
                "readyToClose",
                () => {
                    this.handleMeetingClose();
                }
            );
        },
        handleMeetingClose() {
            const safeRoomId = encodeURIComponent(this.roomId);
            
            if (this.mType === "private") {
                window.location.href = `/conference/user/left/room/#${safeRoomId}`;
            } else {
                window.location.href = `/public/conference/left/room/#${safeRoomId}`;
            }
        },

        destroyMeeting() {
            if (!this._api) {
                return;
            }
            this._api.dispose();
            this._api = null;
        }
    },

    beforeDestroy() {
        this.destroyMeeting();
    }
}
</script>